'use client'

import MenuIcon from '@/components/Icons/MenuIcon'
import XMarkIcon from '@/components/Icons/XMarkIcon'
import LogoButton from '@/components/Layout/LogoButton'
import { cn } from '@/lib/classNames'
import { NAVBAR_LINKS } from '@/lib/texts/header'
import { Dialog, DialogPanel } from '@headlessui/react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useState, type JSX } from 'react'

const MobileMenu = (): JSX.Element => {
  const pathname = usePathname()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="focus:shadow-outline-gray inline-flex size-8 items-center justify-center rounded-md border border-transparent bg-gray-200 text-gray-800 shadow-xs transition duration-150 ease-in-out hover:bg-gray-300 focus:border-gray-700 focus:outline-hidden active:bg-gray-50 active:text-gray-800 md:hidden md:h-10 md:w-10 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
        aria-label="Open Menu"
      >
        <MenuIcon className="block size-5" />
      </button>
      <Dialog
        open={isOpen}
        onClose={closeModal}
        transition
        className="fixed inset-0 z-50 overflow-y-auto transition duration-500 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in md:hidden"
      >
        <div className="fixed inset-0 bg-black/50" />
        <DialogPanel className="absolute mx-auto w-full max-w-2xl bg-white px-6 dark:bg-black">
          <div className="mx-auto lg:px-0">
            <div className="flex items-center justify-between py-4 md:justify-start md:space-x-10 md:py-6">
              <LogoButton />
              <button
                type="button"
                onClick={closeModal}
                className="focus:shadow-outline-gray inline-flex size-8 items-center justify-center rounded-md border border-transparent bg-gray-200 text-gray-800 shadow-xs transition duration-150 ease-in-out hover:bg-gray-300 focus:border-gray-700 focus:outline-hidden active:bg-gray-50 active:text-gray-800 md:hidden md:h-10 md:w-10 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
                aria-label="Close Menu"
              >
                <XMarkIcon className="block size-5" />
              </button>
            </div>
          </div>
          <div className="my-8 space-y-8">
            {NAVBAR_LINKS.map((element) => {
              return (
                <Link
                  key={element.href}
                  href={element.href}
                  onClick={closeModal}
                  className={cn(
                    'flex flex-row items-center text-base font-semibold text-gray-800 dark:text-white',
                    pathname === element.href && 'font-extrabold'
                  )}
                >
                  {element.text}
                </Link>
              )
            })}
          </div>
        </DialogPanel>
      </Dialog>
    </>
  )
}

export default MobileMenu
